module.exports = __webpack_public_path__ + "static/media/rectangle-2.198b9a24.svg";